import type { ThemePreference } from '@staiter/shared';
import { create } from 'zustand';

const STORAGE_KEY = 'staiter.theme';
// TODO(S5): синхронизировать с backend через PUT /me/preferences/theme (UserPreferenceKey='theme').

type Resolved = 'light' | 'dark';

type ThemeState = {
  preference: ThemePreference;
  resolved: Resolved;
  setPreference: (value: ThemePreference) => void;
  init: () => void;
};

function getSystem(): Resolved {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function resolve(pref: ThemePreference): Resolved {
  return pref === 'system' ? getSystem() : pref;
}

function apply(resolved: Resolved): void {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', resolved);
}

function loadStored(): ThemePreference {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'light' || raw === 'dark' || raw === 'system') return raw;
  } catch {
    /* ignore */
  }
  return 'system';
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  preference: 'system',
  resolved: 'light',

  setPreference: (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
    const resolved = resolve(value);
    apply(resolved);
    set({ preference: value, resolved });
  },

  init: () => {
    const preference = loadStored();
    const resolved = resolve(preference);
    apply(resolved);
    set({ preference, resolved });

    // React to system changes только когда preference === 'system'.
    if (typeof window !== 'undefined') {
      const mql = window.matchMedia('(prefers-color-scheme: dark)');
      const onChange = (): void => {
        if (get().preference === 'system') {
          const next = getSystem();
          apply(next);
          set({ resolved: next });
        }
      };
      mql.addEventListener('change', onChange);
    }
  },
}));
